var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1905.76 2065.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6a4dff;\n      }\n\n      .cls-2 {\n        fill: #6e5fff;\n      }\n\n      .cls-3 {\n        fill: #5143dd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1905.76,531.93l-389.02,155.89v520.42c0,104.73-59.49,199.66-151.84,242.28l-412.02,190.16v424.38l821.97-438.6c81.06-43.25,130.91-122.7,130.91-208.63v-885.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,531.93l389.02,155.89v520.42c0,104.73,59.49,199.66,151.84,242.28l412.02,190.16v424.38l-821.97-438.6C49.85,1583.21,0,1503.76,0,1417.84v-885.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1905.76,531.93l-389.02,155.89-472.9-258.09c-79.15-43.19-174.31-40.46-251.03,7.2l-403.79,250.89L0,531.93,804.68,34.67c80.34-44.36,180.37-46.27,262.66-5.02l838.43,502.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M494.73,730.78l461.83,208.64-5.6,579.67-360.03-158.16c-60.09-26.4-97.52-80.85-96.17-139.91l-.04-490.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1406.9,730.78l-450.34,208.64-5.6,579.67,325.04-141.91c83.33-36.38,135.75-111.38,135.02-193.19l-4.12-453.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1406.9,730.78l-395.42-199.78c-58.48-27.97-129.68-25.52-185.49,6.38l-331.26,193.41,461.83,208.64,450.34-208.64Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.73887cb94fa1fde0018dc6c87687aa1a.svg";
export { ForwardRef as ReactComponent };